const { data } = require('jquery')

;(function (module) {
  'use strict'
  module.controller('SignupController', [
    '$scope',
    '$http',
    '$state',
    'ngDialog',
    'authService',
    function ($scope, $http, $state, ngDialog, authService) {
      var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      var passwordRegex = /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,})$/
      $scope.user = {}
      $scope.validate = {
        //'valid', 'invalid', 'not-validated'
        emailValidity: 'not-validated',
        firstNameValidity: 'not-validated',
        lastNameValidity: 'not-validated',
        passwordValidity: 'not-validated',
        confirmValidity: 'not-validated',
      }
      $scope.signup = function () {
        $scope.ajaxload = true
        var isEmailValid = emailRegex.test($scope.user.email)
        if (!isEmailValid) {
          $scope.validate.emailValidity = 'invalid'
        }

        if (!$scope.user.firstName) {
          $scope.validate.firstNameValidity = 'invalid'
        }

        if (!$scope.user.lastName) {
          $scope.validate.lastNameValidity = 'invalid'
        }

        var isPasswordValid = passwordRegex.test($scope.user.password)
        if (!isPasswordValid) {
          $scope.validate.passwordValidity = 'invalid'
        }

        if ($scope.user.password !== $scope.user.confirm) {
          $scope.validate.confirmValidity = 'invalid'
        }

        var emailInvalid = $scope.validate.emailValidity === 'invalid',
          firstNameInvalid = $scope.validate.firstNameValidity === 'invalid',
          lastNameInvalid = $scope.validate.lastNameValidity === 'invalid',
          passwordInvalid = $scope.validate.passwordValidity === 'invalid',
          confirmInvalid = $scope.validate.confirmValidity === 'invalid'
        if (
          emailInvalid ||
          firstNameInvalid ||
          lastNameInvalid ||
          passwordInvalid ||
          confirmInvalid
        ) {
          $scope.ajaxload = false
          const dialog = ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: [
              '$scope',
              function ($scope) {
                $scope.errMsg = ''

                if (firstNameInvalid) {
                  $scope.errMsg += '<p>First name must be entered.</p>'
                }
                if (lastNameInvalid) {
                  $scope.errMsg += '<p>Last name must be entered.</p>'
                }
                if (emailInvalid) {
                  $scope.errMsg += '<p>Email is invalid.</p>'
                }
                if (passwordInvalid) {
                  $scope.errMsg +=
                    '<p>Password must contain minimum 8 characters, and must include at least 1 uppercase letter and 1 digit.</p>'
                }
                if (confirmInvalid) {
                  $scope.errMsg +=
                    '<p>Password and Confirm Password fields do not match.</p>'
                }
                $scope.errTitle = 'Signing Up Error'
              },
            ],
          })

          dialog.closePromise.then(function (data) {})
        } else {
          authService
            .signup(
              $scope.user.email,
              $scope.user.password,
              $scope.user.firstName,
              $scope.user.lastName,
            )
            .then(
              (result) => {
                $scope.ajaxload = false
                const dialog = ngDialog.open({
                  template: 'templates/partials/viewSuccessMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: [
                    '$scope',
                    function ($scope) {
                      $scope.successMsg = result.data
                      $scope.strTitle = 'Sign UP Successful'
                    },
                  ],
                })
                dialog.closePromise.then(function (data) {
                  if (isMobile.any()) {
                    $state.go('closepage')
                  } else {
                    $state.go('login')
                  }
                })
              },
              (error) => {
                $scope.ajaxload = false
                const dialog = ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: [
                    '$scope',
                    function ($scope) {
                      $scope.errMsg = `<p>${error.data}</p>`
                      $scope.errTitle = 'Signing Up Error'
                    },
                  ],
                })
                dialog.closePromise.then(function (data) {})
              },
            )
        }
      }

      $scope.emailKeypress = function () {
        var isValid = emailRegex.test($scope.user.email)
        $scope.validate.emailValidity = isValid ? 'valid' : 'not-validated'
      }

      $scope.firstNameKeypress = function () {
        $scope.validate.firstNameValidity =
          $scope.user.firstName.length > 0 ? 'valid' : 'not-validated'
      }

      $scope.lastNameKeypress = function () {
        $scope.validate.lastNameValidity =
          $scope.user.lastName.length > 0 ? 'valid' : 'not-validated'
      }

      $scope.passwordKeypress = function () {
        var isValid = passwordRegex.test($scope.user.password)
        $scope.validate.passwordValidity = isValid ? 'valid' : 'not-validated'
      }

      $scope.confirmKeypress = function () {
        if ($scope.user.confirm) {
          var isValid = passwordRegex.test($scope.user.confirm)
          $scope.validate.confirmValidity =
            $scope.user.password === $scope.user.confirm &&
            $scope.user.confirm.length > 0 &&
            isValid
              ? 'valid'
              : 'not-validated'
        } else {
          $scope.validate.confirmValidity = 'not-validated'
        }
      }

      const isMobile = {
        Android: function () {
          return navigator.userAgent.match(/Android/i)
        },
        BlackBerry: function () {
          return navigator.userAgent.match(/BlackBerry/i)
        },
        iOS: function () {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i)
        },
        Opera: function () {
          return navigator.userAgent.match(/Opera Mini/i)
        },
        Windows: function () {
          return (
            navigator.userAgent.match(/IEMobile/i) ||
            navigator.userAgent.match(/WPDesktop/i)
          )
        },
        any: function () {
          return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
          )
        },
      }
    },
  ])
})(angular.module('obex'))



// WEBPACK FOOTER //
// ./client/js/controllers/signupController.js